(function() {

  'use strict';



  if (window.__vq_init_en) return;

  window.__vq_init_en = true;



  /* ── STATS → Google Sheet ── */

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbxCzo6XGex6ceLfENE_5zGTJvjy6NcMO25dV51Ae0HZNhsW0AVcLJloOxHL6QwLwmV8/exec';

  function sendToSheet(params) {

    if (!SHEET_URL) return;

    try {

      var qs = Object.keys(params).map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');

      new Image().src = SHEET_URL + '?' + qs;

    } catch(e) {}

  }



  var DISCOUNT_CODE = 'QUIZ10';

  var DISCOUNT_URL = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';



  var LS_KEY = 'viworo_quiz_en_v1';

  var LS_TTL_MS = 24 * 60 * 60 * 1000;

  function saveProgress() {

    try { localStorage.setItem(LS_KEY, JSON.stringify({ step: currentStep, answers: answers, ts: Date.now() })); } catch(e) {}

  }

  function loadProgress() {

    try {

      var raw = localStorage.getItem(LS_KEY);

      if (!raw) return null;

      var data = JSON.parse(raw);

      if (!data || typeof data.ts !== 'number' || Date.now() - data.ts > LS_TTL_MS) { localStorage.removeItem(LS_KEY); return null; }

      if (!Array.isArray(data.answers) || data.answers.length === 0) return null;

      if (typeof data.step !== 'number' || data.step < 0 || data.step >= QUESTIONS.length) return null;

      return data;

    } catch(e) { return null; }

  }

  function clearProgress() { try { localStorage.removeItem(LS_KEY); } catch(e) {} }



  var UI = {

    topBadge: 'Top pick',

    scentLabel: 'Scent profile:',

    tipLabel: '💡 Tip:',

    ctaBtn: 'Discover now',

    progressOf: 'of',

    whyPrefix: '',

    backBtn: '← Back'

  };



  var OILS = {

    lavanda: {

      handle: 'organic-lavender',

      latin: 'Lavandula angustifolia',

      name: 'True Lavender (Organic)',

      scent: 'Floral, sweet-herbal, calming',

      why: 'The all-rounder of essential oils. Its soft floral scent is cherished in aromatherapy for promoting deep relaxation and restful sleep.',

      tip: '1–2 drops on your pillow for better sleep. Also great diluted for soothing skincare routines.'

    },

    cembro: {

      handle: 'swiss-pine-oil',

      latin: 'Pinus cembra',

      name: 'Stone Pine',

      scent: 'Warm-woody, resinous, alpine',

      why: 'The scent of the Alps. Its warm, woody aroma is traditionally used in Tyrolean bedrooms to create a calm, restful atmosphere for deeper sleep.',

      tip: 'Use in a bedroom diffuser – ideally turn it on 30 minutes before bedtime.'

    },

    ylang: {

      handle: 'organic-ylang-ylang',

      latin: 'Cananga odorata',

      name: 'Ylang-Ylang (Organic)',

      scent: 'Rich floral, sweet, exotic-sensual',

      why: 'Lifts the mood and has a balancing effect. Traditionally known for its harmonising effect on body and mind.',

      tip: 'Use sparingly – 1–2 drops are enough! Wonderful blended with bergamot or cedarwood.'

    },

    cedro: {

      handle: 'organic-cedarwood',

      latin: 'Cedrus atlantica',

      name: 'Cedarwood (Organic)',

      scent: 'Warm-woody, balsamic, grounding',

      why: 'Grounds and centres. Ideal when thoughts are racing and you want to find calm.',

      tip: 'Perfect for meditation and yoga. Blend with lavender for deep evening relaxation.'

    },

    rosmarino: {

      handle: 'organic-rosemary',

      latin: 'Rosmarinus officinalis',

      name: 'Rosemary (Organic)',

      scent: 'Fresh-herbal, camphoraceous, clear',

      why: 'A classic aromatic herb prized for its invigorating, clear scent. In aromatherapy tradition, rosemary is the go-to oil for focused work and mental clarity.',

      tip: '3–4 drops in the diffuser while working. Combine with lemon for an extra freshness boost.'

    },

    menta: {

      handle: 'organic-peppermint',

      latin: 'Mentha piperita',

      name: 'Peppermint (Organic)',

      scent: 'Intensely fresh, cooling, minty-clear',

      why: 'Instantly refreshing and cooling on the skin. The crisp menthol scent awakens the senses and helps you feel alert and clear-headed.',

      tip: 'For a cooling freshness: 1 drop diluted with MCT oil on temples. Not suitable for children under 6.'

    },

    limone: {

      handle: 'organic-lemon',

      latin: 'Citrus limon',

      name: 'Lemon (Organic)',

      scent: 'Zesty-fresh, bright citrusy, invigorating',

      why: 'A beautifully fresh oil that purifies the air, lifts the mood, and promotes concentration.',

      tip: 'Creates a fresh, clean atmosphere in the diffuser. Note: phototoxic on skin – avoid before sun exposure!'

    },

    lemongrass: {

      handle: 'organic-lemongrass',

      latin: 'Cymbopogon flexuosus',

      name: 'Lemongrass (Organic)',

      scent: 'Lemony-herbal, fresh, slightly sweet',

      why: 'Refreshes and invigorates – like a mini holiday. Also a natural insect repellent in summer.',

      tip: 'In summer, use as a natural mosquito repellent in the diffuser or diluted as a room spray.'

    },

    eucalipto: {

      handle: 'organic-eucalyptus-essential-oil',

      latin: 'Eucalyptus globulus',

      name: 'Eucalyptus Globulus (Organic)',

      scent: 'Clear-fresh, camphoraceous, liberating',

      why: 'The classic companion for the cold season. Its powerful, fresh aroma gives a pleasant feeling of breathing freely.',

      tip: 'For stuffy rooms: 3–4 drops in hot water for steam inhalation. Not suitable for children under 6.'

    },

    teatree: {

      handle: 'organic-tea-tree-essential-oil',

      latin: 'Melaleuca alternifolia',

      name: 'Tea Tree (Organic)',

      scent: 'Fresh-medicinal, herbal, purifying',

      why: 'The purifying powerhouse from Australia. Valued for generations in natural skincare for blemish-prone skin and as a freshening room scent.',

      tip: 'Dab 1 drop neat on blemishes. For larger skin areas, always dilute with MCT oil.'

    },

    ravintsara: {

      handle: 'organic-ravintsara',

      latin: 'Cinnamomum camphora ct. 1,8-cineole',

      name: 'Ravintsara (Organic)',

      scent: 'Fresh-camphoraceous, eucalyptus-like, mild',

      why: 'The gentle wellness treasure from Madagascar. Unlike eucalyptus, ravintsara is remarkably mild and skin-friendly – a soothing companion for the whole family.',

      tip: 'During cold season: 2–3 drops on the soles of feet (diluted with MCT oil) before bedtime.'

    },

    cajeput: {

      handle: 'cajeput',

      latin: 'Melaleuca cajuputi',

      name: 'Cajeput (Organic)',

      scent: 'Fresh, mildly eucalyptus-like, gentle',

      why: 'The gentle alternative to eucalyptus, suitable for sensitive people too. In aromatherapy tradition, cajeput is a soft companion for the cold season.',

      tip: 'A good diffuser choice for families with older children (from 6 years) – milder than eucalyptus.'

    },

    pmugo: {

      handle: 'organic-mountain-pine-oil-south-tyrol',

      latin: 'Pinus mugo',

      name: 'Dwarf Pine (Organic)',

      scent: 'Fresh-resinous, camphoraceous, alpine',

      why: 'Alpine breathing helper! Its bracing mountain scent clears the air and brings fresh alpine energy into your home.',

      tip: 'Ideal for the sauna – 2–3 drops in the infusion water for an authentic alpine feeling.'

    },

    bergamotto: {

      handle: 'organic-bergamot-essential-oil',

      latin: 'Citrus bergamia',

      name: 'Bergamot (Organic)',

      scent: 'Citrusy-floral, lightly sweet, elegant',

      why: 'A uniquely elegant citrus oil that both calms and uplifts. Its sophisticated aroma is like sunshine in a bottle – the Earl Grey secret.',

      tip: 'In the diffuser in the evening to beat the blues. Warning: strongly phototoxic – do not apply to skin before sun exposure!'

    },

    arancio: {

      handle: 'organic-sweet-orange',

      latin: 'Citrus sinensis',

      name: 'Sweet Orange (Organic)',

      scent: 'Warm-sweet, fruity, sunny-cheerful',

      why: 'Creates a soothing atmosphere. Calms, lifts the mood, and is one of the most well-tolerated essential oils.',

      tip: 'The perfect starting point for beginners. In the diffuser in the kitchen or living room for a warm atmosphere.'

    },

    incenso: {

      handle: 'organic-frankincense-essential-oil',

      latin: 'Boswellia carterii',

      name: 'Frankincense (Organic)',

      scent: 'Warm-resinous, balsamic, deep',

      why: 'Sacred and grounding. Revered for millennia in meditation traditions, its deep resinous aroma helps quiet the mind and deepen inner stillness.',

      tip: 'For meditation: 2 drops in the diffuser. For mature skin: 1 drop in your face cream (diluted).'

    },

    geranio: {

      handle: 'organic-rose-geranium',

      latin: 'Pelargonium graveolens',

      name: 'Geranium (Organic)',

      scent: 'Rosy-floral, fresh-herbal, balancing',

      why: 'The rose-scented skincare favourite. Loved for balancing all skin types and as a natural insect repellent with a beautiful floral scent.',

      tip: '2–3 drops in your shower gel or shampoo. Blends well with almost all other oils.'

    },

    camomilla: {

      handle: 'organic-roman-chamomile',

      latin: 'Chamaemelum nobile',

      name: 'Roman Chamomile (Organic)',

      scent: 'Warm-herbal, apple-sweet, gentle',

      why: 'Pure gentleness – suitable for children and sensitive skin. Calms body, mind, and irritated skin alike.',

      tip: 'The gentlest calming oil. Ideal for children (diluted) with restlessness or sleep difficulties.'

    },

    pepnero: {

      handle: 'organic-black-pepper-oil',

      latin: 'Piper nigrum',

      name: 'Black Pepper (Organic)',

      scent: 'Spicy-warm, peppery, stimulating',

      why: 'Gently warms from within. Its spicy aroma invigorates the senses and creates a comforting warmth – perfect after exercise or on cold days.',

      tip: 'For a warming massage oil: mix 2–3 drops with MCT oil and massage into tense muscles.'

    },

    palmarosa: {

      handle: 'organic-palmarosa-oil',

      latin: 'Cymbopogon martinii',

      name: 'Palmarosa (Organic)',

      scent: 'Rosy-sweet, fresh-floral, elegant',

      why: 'The rose scent among grass oils. Nurtures all skin types with its lovely floral aroma and is wonderfully balancing.',

      tip: '2–3 drops in your shower gel or body lotion for natural skincare with a rosy scent.'

    },

    patchouli: {

      handle: 'organic-patchouli',

      latin: 'Pogostemon cablin',

      name: 'Patchouli (Organic)',

      scent: 'Deeply earthy, warm-sweet, sensual',

      why: 'The deepest of all scents. Grounds like no other oil, supports skin regeneration, and gets better with age.',

      tip: 'Less is more – 1–2 drops are enough! Blend with sweet orange for a beautiful warm-sweet scent.'

    },

    wintergruen: {

      handle: 'organic-wintergreen-oil',

      latin: 'Gaultheria procumbens',

      name: 'Wintergreen (Organic)',

      scent: 'Sweet-medicinal, minty-warm, intense',

      why: 'An athlete\'s favourite. Its intensely warming character on the skin makes it a classic in massage blends after intense physical activity.',

      tip: 'Very concentrated! Dilute max 1% (2 drops in 10 ml MCT oil). Not with blood thinners, pregnancy, or children.'

    },

    cipresso: {

      handle: 'organic-cypress',

      latin: 'Cupressus sempervirens',

      name: 'Cypress (Organic)',

      scent: 'Fresh-woody, resinous, Mediterranean-elegant',

      why: 'Tuscany in a bottle. Harmonises and centres – ideal for inner restlessness and meditation.',

      tip: 'Perfect for yoga and meditation. Blend with cedarwood and frankincense for deep grounding.'

    },

    litsea: {

      handle: 'bio-litsea-cubeba-essential-oil',

      latin: 'Litsea cubeba',

      name: 'Litsea Cubeba (Organic)',

      scent: 'Lemony-sweet, fresh-floral, cheerful',

      why: 'Like a gentle ray of sunshine. The scent recalls lemon but softer and more floral – lifts the mood without being phototoxic.',

      tip: 'The non-phototoxic alternative to citrus oils for skin use. 3–4 drops in the diffuser for a good mood.'

    },

    mandarino: {

      handle: 'organic-red-mandarin',

      latin: 'Citrus reticulata',

      name: 'Red Mandarin (Organic)',

      scent: 'Warm-sweet, softly fruity, gently cheerful',

      why: 'Especially mild and gentle – wonderfully suitable even for little ones. Calms, comforts, and brings good cheer.',

      tip: 'For children: 1–2 drops in the diffuser as a sleep aid. Blend with lavender for the perfect goodnight duo.'

    },

    citronella: {

      handle: 'organic-citronella-essential-oil',

      latin: 'Cymbopogon nardus',

      name: 'Citronella (Organic)',

      scent: 'Fresh-green, lemony-rosy, distinctive',

      why: 'The #1 natural mosquito repellent. Refreshes the air and keeps pesky insects away in summer.',

      tip: 'DIY mosquito spray: 10–15 drops + 100 ml water + 1 tbsp alcohol in spray bottle. Refresh every 2–3 hours.'

    },

    eucitriodora: {

      handle: 'organic-eucalyptus-citriodora',

      latin: 'Corymbia citriodora',

      name: 'Lemon Eucalyptus (Organic)',

      scent: 'Lemony-fresh, slightly rosy, bright',

      why: 'The elegant sister of eucalyptus – lemony instead of medicinal! Also a well-known natural insect repellent.',

      tip: 'Different from Eucalyptus Globulus: lemony-fresh, ideal as summer scent and insect repellent. Also lovely in the evening diffuser.'

    },

    lavhybrida: {

      handle: 'lavender-essential-oil',

      latin: 'Lavandula x hybrida',

      name: 'Lavandin (Organic)',

      scent: 'Fresh-herbal, more camphoraceous than lavender, clear',

      why: 'The fresher sister of lavender. More camphor freshness, stronger scent – ideal for room fragrance and cleaning.',

      tip: 'More affordable than True Lavender and more intense – perfect for the living room diffuser and DIY cleaning sprays.'

    },

    garofano: {

      handle: 'organic-clove',

      latin: 'Eugenia caryophyllus',

      name: 'Clove Bud (Organic)',

      scent: 'Warm-spicy, intense, deeply sweet',

      why: 'A warming winter classic. Its rich, spicy scent creates a sense of cosiness – like mulled wine on a cold evening.',

      tip: 'Extremely intense – only 1–2 drops in the diffuser! Great with orange and cinnamon for a festive atmosphere.'

    },

    timo: {

      handle: 'thyme-essential-oil',

      latin: 'Thymus vulgaris',

      name: 'Thyme (Organic)',

      scent: 'Strong-herbal, warm-spicy, intense',

      why: 'The power herb from the Mediterranean. A warming, robust scent traditionally used during the cold season to create a fortifying atmosphere.',

      tip: 'Strong and intense – only 1–2 drops in the diffuser! Blend with lemon for a fresher, milder scent.'

    },

    zimtblatt: {

      handle: 'organic-cinnamon-leaf',

      latin: 'Cinnamomum verum',

      name: 'Cinnamon Leaf (Organic)',

      scent: 'Warm-spicy, sweet-cinnamon, cosy',

      why: 'Warmth for the soul. Creates instant cosiness and well-being – perfect for the cold season.',

      tip: 'Only 2–3 drops in the diffuser – very intense! Christmas blend: cinnamon + orange + clove.'

    },

    pompelmo: {

      handle: 'organic-grapefruit',

      latin: 'Citrus paradisi',

      name: 'Grapefruit (Organic)',

      scent: 'Tart-citrusy, slightly bitter, invigorating',

      why: 'Tart and refreshing – brighter than orange, ideal for an invigorating morning and clear thoughts.',

      tip: 'In the diffuser in the morning for a fresh start to the day. Note: phototoxic on skin!'

    },

    salviamos: {

      handle: 'organic-clary-sage',

      latin: 'Salvia sclarea',

      name: 'Clary Sage (Organic)',

      scent: 'Herbal-warm, nutty-sweet, deep',

      why: 'A deeply soothing and balancing oil. Traditionally treasured for creating harmony and lifting the spirits during stressful times.',

      tip: 'For restlessness: 3–4 drops in the diffuser. Blend with lavender and geranium for a harmonious mix.'

    },

    petitgrain: {

      handle: 'organic-petitgrain',

      latin: 'Citrus aurantium',

      name: 'Petitgrain (Organic)',

      scent: 'Green-fresh, floral-herbal, elegant',

      why: "Affordable neroli! Calms the mind, eases tension, and smells wonderfully fresh-floral – at a fraction of neroli's price.",

      tip: 'For intense work or study phases: 2–3 drops in the diffuser. Blend with bergamot for pure relaxation.'

    },

    fichte: {

      handle: 'organic-spruce',

      latin: 'Picea abies',

      name: 'Spruce (Organic)',

      scent: 'Fresh, coniferous, invigorating',

      why: 'A bracing forest scent that invigorates the mind and refreshes the spirit – like a walk through a spruce forest after rain.',

      tip: 'Excellent for invigorating sauna infusions or as a revitalising bath additive.'

    },

    laerche: {

      handle: 'organic-larch',

      latin: 'Larix decidua',

      name: 'Larch (Organic)',

      scent: 'Warm-woody, balsamic, gentle',

      why: 'A rare and gentle conifer oil that provides emotional comfort and a feeling of sheltered warmth.',

      tip: 'A very well-tolerated conifer oil, ideal for those seeking stability and grounding.'

    },

    blutorange: {

      handle: 'organic-blood-orange',

      latin: 'Citrus sinensis',

      name: 'Blood Orange (Organic)',

      scent: 'Sparkling-sweet, intense, sunny',

      why: 'Instant cheerfulness in a bottle. Its rich, sunny scent brightens any room and lifts the spirits on grey days.',

      tip: 'Our favourite for creating a warm, welcoming atmosphere in family spaces.'

    },

    limette: {

      handle: 'organic-lime',

      latin: 'Citrus aurantifolia',

      name: 'Lime (Organic)',

      scent: 'Tart-fresh, sparkling, stimulating',

      why: 'More activating than lemon. Clears foggy thoughts and promotes creative concentration.',

      tip: 'Ideal for the desk diffuser or to combat mid-morning fatigue.'

    },

    kuemmel: {

      handle: 'organic-cumin-hungary',

      latin: 'Carum carvi',

      name: 'Caraway (Organic)',

      scent: 'Spicy, earthy, distinctive',

      why: 'A spicy, characteristic oil from centuries of Mediterranean tradition. Its earthy scent is a well-known companion in aromatherapy for moments of warmth and quiet.',

      tip: 'Diluted into MCT oil at 1% for a warming, cosy evening belly compress after heavy meals.'

    },

    fenchel: {

      handle: 'fennel-essential-oil-organic',

      latin: 'Foeniculum vulgare',

      name: 'Fennel (Organic)',

      scent: 'Sweet, anise-like, warm',

      why: 'A soft-sweet classic of Mediterranean cuisine. Its mellow, anise-like scent is known in aromatherapy for its calm, harmonising note.',

      tip: 'Diluted (max 1%) in a carrier oil for a gentle, warm evening rub on the upper abdomen.'

    },

    anis: {

      handle: 'organic-star-anise-essential-oil',

      latin: 'Illicium verum',

      name: 'Star Anise (Organic)',

      scent: 'Sweet, spicy, warming',

      why: 'A warm, enveloping scent that brings a sense of comfort during the cold season and creates a cosy atmosphere.',

      tip: '2–3 drops in the diffuser with sweet orange and cinnamon – a classic winter scent for the living room.'

    },

    oregano: {

      handle: 'organic-oregano',

      latin: 'Origanum vulgare',

      name: 'Oregano (Organic)',

      scent: 'Herbaceous, spicy, intense',

      why: 'The most powerful herb oil in aromatherapy. Extremely potent and warming – a serious oil for experienced users.',

      tip: 'Only use under expert guidance! Highly irritating – never apply undiluted to skin.'

    },

    salbei: {

      handle: 'organic-sage',

      latin: 'Salvia officinalis',

      name: 'Sage (Organic)',

      scent: 'Herbal, clear, bitter',

      why: 'Strongly purifying for mind and space. Its intense herbal scent has been used in cleansing rituals across cultures for centuries.',

      tip: 'Use with caution – very potent. Do not use during pregnancy.'

    }

  };



  /* ── IT-HANDLES (canonical Shopify handles for API fetches) ── */

  var IT_HANDLES = {

    'organic-lavender': 'bio-lavanda-vera',

    'swiss-pine-oil': 'olio-di-pino-cembro-bio',

    'organic-ylang-ylang': 'bio-ylang-ylang',

    'organic-cedarwood': 'bio-cedro',

    'organic-rosemary': 'rosmarinus',

    'organic-peppermint': 'bio-menta-piperita',

    'organic-lemon': 'bio-limone',

    'organic-lemongrass': 'bio-lemongrass',

    'organic-eucalyptus-essential-oil': 'bio-eucalipto',

    'organic-tea-tree-essential-oil': 'tea-tree-bio',

    'organic-ravintsara': 'ravintsara',

    'cajeput': 'cajeput',

    'organic-mountain-pine-oil-south-tyrol': 'bio-pino-mugo',

    'organic-bergamot-essential-oil': 'bio-bergamotto',

    'organic-sweet-orange': 'bio-arancio-dolce',

    'organic-frankincense-essential-oil': 'incenso',

    'organic-rose-geranium': 'geranio',

    'camomilla-romana-bio': 'camomilla-romana-bio',

    'organic-black-pepper-oil': 'olio-di-pepe-nero-bio',

    'organic-palmarosa-oil': 'olio-di-palmarosa-bio-nepal',

    'organic-patchouli': 'patchouli',

    'olio-di-wintergreen-biologico': 'olio-di-wintergreen-biologico',

    'organic-cypress': 'cypress',

    'bio-litsea-cubeba-essential-oil': 'bio-litsea-cubeba-olio-essenziale',

    'organic-red-mandarin': 'bio-mandarino-rosso',

    'organic-citronella-essential-oil': 'citronella',

    'olio-di-eucalipto-citriodora-biologico': 'olio-di-eucalipto-citriodora-biologico',

    'lavender-essential-oil': 'bio-lavanda',

    'organic-clove': 'chiodi-di-garofano',

    'thyme-essential-oil': 'olio-essenziale-di-timo-bio',

    'cannella': 'cannella',

    'pompelmo-bio': 'pompelmo-bio',

    'organic-clary-sage': 'salvia-moscatella',

    'organic-petitgrain': 'petitgrain',

    'organic-spruce': 'bio-abete-rosso',

    'bio-larice': 'bio-larice',

    'organic-blood-orange': 'bio-arancia-rossa',

    'bio-limetta': 'bio-limetta',

    'cumino-bio-dallungheria': 'cumino-bio-dallungheria',

    'fennel-essential-oil-organic': 'olio-essenziale-di-finocchio-biologico',

    'organic-star-anise-essential-oil': 'anice-stellato',

    'organic-oregano': 'oregano',

    'organic-sage': 'salvia'

  };



  function getItHandle(handle) {

    return IT_HANDLES[handle] || handle;

  }





  var QUESTIONS = [

    {

      title: 'What is your main goal?',

      subtitle: 'Choose the area that is your top priority.',

      options: [

        { icon: '🌲', label: 'Forest Power & Clear Airways', desc: 'Deep regeneration and free breathing like in the high mountains.', scores: { fichte: 14, laerche: 13, cembro: 10, pmugo: 10, eucalipto: 16, ravintsara: 10, lavhybrida: 3, citronella: 2 } },

        { icon: '⚡', label: 'Energy & Mood Boost', desc: 'Instant cheerfulness and mental alertness.', scores: { blutorange: 15, limette: 12, limone: 10, pompelmo: 10, rosmarino: 10, litsea: 8, arancio: 7, lemongrass: 5 } },

        { icon: '😴', label: 'Deep Relaxation & Sleep', desc: 'Switch off your mind and improve sleep quality.', scores: { cembro: 15, lavanda: 12, incenso: 12, camomilla: 10, cedro: 8, ylang: 8, mandarino: 8, salviamos: 7, patchouli: 6, petitgrain: 5 } },

        { icon: '🧘', label: 'Gut Feeling & Inner Balance', desc: 'Warmth for the belly area and a sense of inner grounding.', scores: { kuemmel: 15, fenchel: 12, anis: 10, menta: 13, salbei: 5 } },

        { icon: '🛡️', label: 'Protection & Room Atmosphere', desc: 'Natural companions for the cold season and a fresh room atmosphere.', scores: { ravintsara: 15, teatree: 12, timo: 10, oregano: 10, garofano: 8, eucalipto: 12, cajeput: 7, citronella: 3, salbei: 5 } },

        { icon: '💪', label: 'Muscles & Recovery', desc: 'Warmth and relaxation after intense physical activity.', scores: { wintergruen: 15, pepnero: 12, rosmarino: 10, menta: 8, fichte: 5 } }

      ]

    },

    {

      title: 'How are you feeling right now?',

      subtitle: 'Choose your current emotional or physical state.',

      options: [

        { icon: '😰', label: 'Stressed & Tense', desc: 'Too many thoughts, inner restlessness.', scores: { lavanda: 10, bergamotto: 10, cedro: 8, ylang: 7, blutorange: 7, cipresso: 6, salviamos: 5, petitgrain: 5, geranio: 3, palmarosa: 3, incenso: 8 } },

        { icon: '😴', label: 'Tired & Listless', desc: 'Need a focus boost.', scores: { limone: 10, rosmarino: 10, menta: 14, limette: 8, pompelmo: 8, litsea: 7, lemongrass: 5 } },

        { icon: '🤒', label: 'Congested & Under the Weather', desc: 'First signs of a cold.', scores: { fichte: 10, ravintsara: 10, eucalipto: 8, timo: 8, cajeput: 7, pmugo: 7, laerche: 7, lavhybrida: 3, eucitriodora: 3 } },

        { icon: '😟', label: 'Overwhelmed & Vulnerable', desc: 'Seeking protection and comfort.', scores: { laerche: 12, incenso: 18, cedro: 10, patchouli: 7, arancio: 6 } },

        { icon: '😣', label: 'Bloated & Uncomfortable', desc: 'Pressure in the abdominal area.', scores: { kuemmel: 12, fenchel: 10, anis: 8, camomilla: 5 } }

      ]

    },

    {

      title: 'Which scent direction do you prefer?',

      subtitle: 'This helps us find your personal favourite oil.',

      options: [

        { icon: '🌲', label: 'Woody & Clear', desc: 'Fir, Stone Pine, Larch, Spruce', scores: { fichte: 5, laerche: 5, cembro: 5, pmugo: 5, cipresso: 7, salbei: 3 } },

        { icon: '🍋', label: 'Citrusy & Fresh', desc: 'Lemon, Orange, Lime, Bergamot', scores: { limone: 5, blutorange: 5, limette: 5, pompelmo: 5, litsea: 5, arancio: 4, bergamotto: 4, eucitriodora: 3, lemongrass: 4, citronella: 3 } },

        { icon: '🌸', label: 'Floral & Soft', desc: 'Lavender, Geranium, Ylang Ylang', scores: { lavanda: 5, geranio: 5, ylang: 5, palmarosa: 5, camomilla: 4, salviamos: 3, lavhybrida: 3, petitgrain: 3 } },

        { icon: '🪵', label: 'Spicy & Earthy', desc: 'Cedar, Patchouli, Frankincense, Pepper', scores: { cedro: 5, patchouli: 5, incenso: 5, pepnero: 4, kuemmel: 4, garofano: 3, zimtblatt: 3 } },

        { icon: '🎲', label: 'Surprise me!', desc: 'No preference – I\'m open to anything.', scores: {} }

      ]

    },

    {

      title: 'Almost done – one last detail for your personal recommendation',

      subtitle: 'This helps us pick the oils that fit best into your everyday life.',

      options: [

        { icon: '✅', label: 'Just for me – no restrictions', desc: 'Show me your best recommendations.', scores: {} },

        { icon: '🤰', label: 'Pregnancy / Nursing', desc: 'We will only recommend gentle oils.', scores: { salbei: -20, salviamos: -20, wintergruen: -20, timo: -20, garofano: -20, zimtblatt: -20, oregano: -20, menta: -10, rosmarino: -5 } },

        { icon: '👶', label: 'Young children in the household', desc: 'We will choose especially mild oils for you.', scores: { menta: -20, eucalipto: -20, timo: -20, oregano: -20, wintergruen: -20, garofano: -20, salbei: -20 } },

        { icon: '🧴', label: 'Very sensitive skin', desc: 'We will avoid irritating components.', scores: { timo: -10, oregano: -10, garofano: -10, zimtblatt: -10, menta: -5, limone: -2, lemongrass: -3 } }

      ]

    },
    {
      title: 'How would you like to use your oil?',
      subtitle: 'So we can give you the right tip and the right size.',
      options: [
        { icon: '💨', label: 'In a diffuser & for the room', desc: 'Scent for living room, office or bedroom.', scores: { limone: 2, blutorange: 2, bergamotto: 2, lavanda: 2, eucalipto: 2, cembro: 2 } },
        { icon: '🤲', label: 'On the skin & for massage', desc: 'Diluted with a carrier oil.', scores: { lavanda: 3, geranio: 2, palmarosa: 2, camomilla: 2, incenso: 2, menta: -3, timo: -3, oregano: -3 } },
        { icon: '🔥', label: 'For sauna & bath', desc: 'Sauna infusion and bath additive.', scores: { fichte: 3, pmugo: 3, laerche: 3, cembro: 3, eucalipto: 2, rosmarino: 2 } },
        { icon: '🤔', label: 'I do not know yet', desc: 'Just show me the best recommendation.', scores: {} }
      ]
    }
  ];



  /* ── TRACKING (GA4 / GTM) ── */

  function trackEvent(name, params) {

    try {

      if (typeof gtag === 'function') gtag('event', name, params || {});

      if (window.dataLayer) { var e = { event: name }; if (params) { for (var k in params) { e[k] = params[k]; } } dataLayer.push(e); }

    } catch(err) {}

  }



  var currentStep = -1;

  var answers = [];

  var totalQuestions = QUESTIONS.length;



  var quizEl = document.getElementById('viworo-quiz');

  var introEl = quizEl.querySelector('.vq-intro');

  var progressWrap = quizEl.querySelector('.vq-progress-wrap');

  var progressFill = quizEl.querySelector('.vq-progress-fill');

  var progressText = quizEl.querySelector('.vq-progress-text');

  var questionEl = quizEl.querySelector('.vq-question');

  var resultsEl = quizEl.querySelector('.vq-results');



  function showScreen(name) {
    /* V2: Ratgebertext und FAQ nur ausserhalb des Ergebnisses zeigen. */
    try { document.body.classList.toggle('vq-ergebnis', name === 'results'); } catch(e) {}

    [introEl, questionEl, resultsEl].forEach(function(s) {

      s.style.display = 'none';

      s.classList.remove('active');

    });

    progressWrap.style.display = (name === 'question') ? 'flex' : 'none';

    var target = name === 'intro' ? introEl : name === 'question' ? questionEl : resultsEl;

    target.style.display = 'block';

    target.setAttribute('tabindex', '-1');

    target.focus();

    setTimeout(function() { target.classList.add('active'); }, 10);

  }



  function showScreenFocus(name) {

    /* Focus auf Title-Heading, nicht auf Container (A11y) */

    var target = name === 'question' ? questionEl.querySelector('.vq-q-title') :

                 name === 'results' ? resultsEl.querySelector('.vq-results-title') :

                 introEl.querySelector('.vq-title') || introEl;

    if (target) { target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: false }); }

  }



  function startQuiz() {

    trackEvent('quiz_start');

    sendToSheet({ t: 'start', lang: 'en' });

    currentStep = 0;

    answers = [];

    clearProgress();

    showScreen('question');

    requestAnimationFrame(function() { showScreenFocus('question'); });

    renderQuestion(0);

  }



  function resumeQuiz(data) {

    trackEvent('quiz_resume', { quiz_step: data.step + 1 });

    currentStep = data.step;

    answers = data.answers.slice();

    showScreen('question');

    renderQuestion(currentStep);

  }



  function goBack() {

    if (currentStep > 0) {

      currentStep--;

      answers.pop();

      saveProgress();

      renderQuestion(currentStep);

    }

  }



  var isTransitioning = false;

  function selectOption(optIndex) {

    if (isTransitioning) return;

    isTransitioning = true;

    trackEvent('quiz_answer', { quiz_step: currentStep + 1, quiz_choice: QUESTIONS[currentStep].options[optIndex].label });

    var options = questionEl.querySelectorAll('.vq-option');

    for (var i = 0; i < options.length; i++) {

      options[i].setAttribute('aria-pressed', i === optIndex ? 'true' : 'false');

      options[i].classList.toggle('vq-selected', i === optIndex);

    }

    answers[currentStep] = optIndex;

    setTimeout(function() {

      currentStep++;

      isTransitioning = false;

      if (currentStep < totalQuestions) {

        saveProgress();

        renderQuestion(currentStep);

        requestAnimationFrame(function() { showScreenFocus('question'); });

      } else {

        showResults();

      }

    }, 120);

  }



  function renderQuestion(idx) {

    var q = QUESTIONS[idx];

    var pct = ((idx + 1) / totalQuestions) * 100;

    progressFill.style.width = pct + '%';

    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', Math.round(pct));

    progressText.textContent = (idx + 1) + ' ' + UI.progressOf + ' ' + totalQuestions;

    questionEl.querySelector('.vq-q-title').textContent = q.title;

    questionEl.querySelector('.vq-q-subtitle').textContent = q.subtitle;

    var optWrap = questionEl.querySelector('.vq-options');

    optWrap.innerHTML = '';

    q.options.forEach(function(opt, i) {

      var card = document.createElement('button');

      card.type = 'button';

      card.className = 'vq-option';

      card.setAttribute('aria-pressed', 'false');

      card.innerHTML =

        '<span class="vq-option-icon" aria-hidden="true">' + opt.icon + '</span>' +

        '<span class="vq-option-text">' +

          '<span class="vq-option-label">' + opt.label + '</span>' +

          '<span class="vq-option-desc">' + opt.desc + '</span>' +

        '</span>';

      card.addEventListener('click', function() { selectOption(i); });

      optWrap.appendChild(card);

    });

    var backBtn = questionEl.querySelector('.vq-btn-back');

    backBtn.style.display = idx > 0 ? 'inline-block' : 'none';

    showScreen('question');

  }



  /* Hard-Stop: Oils completely excluded for safety */

  var BLACKLIST = {

    /* Q4 Index 1 = Pregnancy */

    1: ['wintergruen', 'salviamos', 'salbei', 'timo', 'garofano', 'zimtblatt', 'oregano', 'menta', 'rosmarino', 'fenchel'],

    /* Q4 Index 2 = Children */

    2: ['wintergruen', 'menta', 'eucalipto', 'timo', 'oregano', 'garofano', 'salbei']

  };



  /* Synergy: Oil pairs that reinforce each other */

  var SYNERGIES = [

    { oils: ['lavanda', 'cedro'], context: [2], bonus: 4 },

    { oils: ['lavanda', 'cembro'], context: [2], bonus: 4 },

    { oils: ['eucalipto', 'ravintsara'], context: [0, 4], bonus: 4 },

    { oils: ['bergamotto', 'arancio'], context: [1], bonus: 4 },

    { oils: ['pepnero', 'rosmarino'], context: [5], bonus: 4 },

    { oils: ['menta', 'rosmarino'], context: [1], bonus: 2 },

    { oils: ['kuemmel', 'fenchel'], context: [3], bonus: 4 },

    { oils: ['fichte', 'laerche'], context: [0], bonus: 4 }

  ];



  function calculateScores() {

    var scores = {};

    var reasons = {};

    Object.keys(OILS).forEach(function(key) { scores[key] = 0; reasons[key] = []; });

    answers.forEach(function(optIdx, qIdx) {

      var opt = QUESTIONS[qIdx].options[optIdx];

      var weight = (qIdx === 0) ? 2 : 1;

      if (opt && opt.scores) {

        Object.keys(opt.scores).forEach(function(oilKey) {

          if (scores[oilKey] !== undefined) {

            scores[oilKey] += opt.scores[oilKey] * weight;

            if (opt.scores[oilKey] > 0) {

              reasons[oilKey].push({ q: qIdx, label: opt.label, contribution: opt.scores[oilKey] * weight });

            }

          }

        });

      }

    });



    var q4 = answers[3];

    var banned = BLACKLIST[q4] || [];

    banned.forEach(function(key) { delete scores[key]; delete reasons[key]; });



    var q1 = answers[0];

    SYNERGIES.forEach(function(syn) {

      if (syn.context.indexOf(q1) === -1) return;

      var allPositive = syn.oils.every(function(o) { return scores[o] && scores[o] > 0; });

      if (allPositive) {

        syn.oils.forEach(function(o) { scores[o] += syn.bonus; });

      }

    });



    var positive = Object.keys(scores).filter(function(k) { return scores[k] > 0; });

    positive.sort(function(a, b) {

      var diff = scores[b] - scores[a];

      return diff !== 0 ? diff : (a < b ? -1 : 1);

    });

    var maxScore = positive.length > 0 ? scores[positive[0]] : 1;

    var results = [];

    for (var i = 0; i < positive.length && results.length < 3; i++) {

      var key = positive[i];

      var matchPct = Math.round((scores[key] / maxScore) * 100);

      var topReasons = (reasons[key] || []).slice().sort(function(a, b) { return b.contribution - a.contribution; }).slice(0, 2);

      results.push({ key: key, score: scores[key], match: matchPct, reasons: topReasons });

    }

    if (results.length === 0) { results.push({ key: 'lavanda', score: 1, match: null, reasons: [] }); }

    return results;

  }



  function markUnavailable(btn) {

    if (!btn) return;

    btn.disabled = true;

    btn.style.background = '#9ca3af';

    btn.style.cursor = 'default';

    btn.innerHTML = 'Currently unavailable';

    btn.setAttribute('aria-label', 'Currently unavailable');

  }



  function getProductUrl(handle) {

    var root = quizEl.getAttribute('data-root-url') || '';

    if (root && root !== '/') {

      if (root.charAt(root.length - 1) !== '/') root += '/';

      return root + 'products/' + handle;

    }

    var path = window.location.pathname;

    var prefixes = ['/en-ch/', '/en/'];

    var base = '/en';

    for (var i = 0; i < prefixes.length; i++) {

      if (path.indexOf(prefixes[i]) === 0) {

        base = prefixes[i].slice(0, -1);

        break;

      }

    }

    return base + '/products/' + handle;

  }



  /* ════════════════════════════════════════════════════════════════
     QUIZ V2 (29.08.2026) — neuer Ergebnisbildschirm
     - eine klare Nr. 1 mit Produktbild, ein Hauptknopf
     - Daten (Titel/Preis/Bild/Varianten) aus dem MARKT, nicht aus dem Code
     - ausverkaufte Oele werden nie Nr. 1
     - "Ueberrasch mich" bekommt eine Entscheidung statt einer Auswahl
     - Groessenwahl, Set-Preis, Versandbalken, Sticky-Kaufleiste
     ════════════════════════════════════════════════════════════════ */

  var V2 = {"lang": "en", "q1": {"0": "you are looking for forest power and clear airways", "1": "you want energy and good spirits", "2": "you want to sleep better", "3": "you are looking for inner balance", "4": "you want a companion for the cold season", "5": "you want to recover after sport"}, "q2": {"0": "you feel tense", "1": "you feel tired", "2": "you feel run down", "3": "you need protection", "4": "you feel bloated"}, "q5": {"0": "In a diffuser, 3\u20135 drops are enough.", "1": "On skin, always dilute with a carrier oil.", "2": "For sauna use, the 30 ml bottle is worthwhile.", "3": ""}, "und": " and ", "weil": "This suits you because ", "titel": "Your oil: {oel}", "sub": "From more than 35 organic oils, the one that best matches your answers.", "titelUeberrasch": "We decided for you.", "subUeberrasch": "You wanted to be surprised \u2013 here is the one oil that suits you.", "badge": "Top match", "badgeUeberrasch": "Your surprise", "warumTitel": "Why this oil", "punkt1": "You chose {x}.", "punkt2": "You feel {x}.", "cta": "Add to cart", "ctaUeberrasch": "Yes, I will try it", "zurSeite": "Go to product page", "proAnwendung": "From {p} \u20ac per use \u00b7 about 250 drops", "groesseLabel": "Choose size", "auchPassend": "Also suitable", "altAufklappen": "Want to compare? Show two alternatives", "setTitel": "All {n} together", "setBtn": "Add set to cart", "dazuPasst": "Goes well with", "hinzu": "Add", "wirdHinzu": "Adding\u2026", "imKorb": "In cart", "fehler": "Error \u2013 try again", "sicher": "We excluded {n} oils that do not match what you told us.", "versandSchwelle": 55, "versandNoch": "{x} to go for free shipping", "versandFrei": "\u2713 Free shipping reached", "versandKurz": "Free shipping from 55 \u20ac", "codeText": "10 % on your quiz order \u00b7 one per customer", "codeBtn": "Apply", "laedt": "Loading your recommendation\u2026", "leer": "None of the matching oils is available right now. Please check back later.", "zubehoer": {"0": "ultrasonic-diffuser-400m", "1": "olio-mct-bio", "2": null, "3": null}, "zubehoerText": {"0": "3\u20135 drops are enough for the whole room", "1": "For diluting on skin and for massage", "2": "", "3": ""}, "tipp": {"0": "3\u20135 drops in the diffuser \u2013 for rooms up to about 30 m\u00b2.", "1": "Dilute with a carrier oil: 2\u20133 drops in a teaspoon of MCT oil.", "2": "For sauna use, 5\u201310 drops in one litre of water \u2013 never neat on the stones.", "3": null}};

  function fmtPreis(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Produktdaten vom AKTUELLEN Markt holen (richtige Sprache, richtiger Preis). */
  function ladeProdukt(handle) {
    var url = getProductUrl(handle) + '.js';
    return fetch(url)
      .then(function(r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .then(function(p) {
        var varianten = (p.variants || []).filter(function(v) { return v.available; });
        return {
          ok: varianten.length > 0,
          handle: handle,
          titel: p.title || '',
          bild: p.featured_image || (p.images && p.images[0]) || null,
          varianten: varianten.map(function(v) {
            return { id: v.id, titel: v.title, preis: v.price };
          })
        };
      })
      .catch(function() { return { ok: false, handle: handle, titel: '', bild: null, varianten: [] }; });
  }

  /* Ein Satz, der ALLE Antworten aufgreift - nicht nur Frage 1 und 3. */
  function begruendung() {
    var teile = [];
    if (V2.q1[answers[0]]) teile.push(V2.q1[answers[0]]);
    if (V2.q2[answers[1]]) teile.push(V2.q2[answers[1]]);
    var satz = teile.length === 2 ? (teile[0] + V2.und + teile[1])
             : teile.length === 1 ? teile[0] : '';
    if (!satz) return '';
    var s = V2.weil + satz + '.';
    if (answers[4] !== undefined && V2.q5[answers[4]]) s += ' ' + V2.q5[answers[4]];
    return s;
  }

  /* Wurden Oele aus Sicherheitsgruenden ausgeschlossen? Das gehoert sichtbar gemacht. */
  function ausgeschlossen() {
    var b = BLACKLIST[answers[3]];
    return (b && b.length) ? b.length : 0;
  }

  /* Zubehoer passend zur Anwendung (Frage 5). */
  function zubehoerHandle() {
    if (answers[4] === undefined) return null;
    var z = V2.zubehoer[answers[4]];
    return z || null;
  }

  function showResults() {
    var results = calculateScores();
    var namen = results.map(function(r) { return OILS[r.key].name; });
    trackEvent('quiz_complete', { quiz_top1: namen[0] || '', quiz_top2: namen[1] || '', quiz_top3: namen[2] || '' });
    var sheetDaten = {
      t: 'done', lang: V2.lang,
      q1: answers[0] !== undefined ? QUESTIONS[0].options[answers[0]].label : '',
      q2: answers[1] !== undefined ? QUESTIONS[1].options[answers[1]].label : '',
      q3: answers[2] !== undefined ? QUESTIONS[2].options[answers[2]].label : '',
      q4: answers[3] !== undefined ? QUESTIONS[3].options[answers[3]].label : '',
      q5: (answers[4] !== undefined && QUESTIONS[4]) ? QUESTIONS[4].options[answers[4]].label : '',
      r1: namen[0] || '', r2: namen[1] || '', r3: namen[2] || ''
    };
    sendToSheet(sheetDaten);

    progressFill.style.width = '100%';
    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', 100);
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '<div class="vq-laedt">' + V2.laedt + '</div>';
    var stale = resultsEl.querySelectorAll('.vq-urgency-banner, .vq-bundle-wrap, .vq-share-wrap, .vq-discount-box, .vq-v2-block, .vq-sticky');
    for (var s = 0; s < stale.length; s++) { stale[s].remove(); }
    showScreen('results');

    /* Erst alle Produktdaten holen, dann rendern - so steht nie ein falscher
       Preis auf dem Schirm und Ausverkauftes wird gar nicht erst Nr. 1. */
    var alle = results.map(function(r) { return ladeProdukt(OILS[r.key].handle); });
    var zh = zubehoerHandle();
    if (zh) alle.push(ladeProdukt(zh));

    Promise.all(alle).then(function(prods) {
      var zubehoer = zh ? prods.pop() : null;
      var paare = [];
      for (var i = 0; i < results.length; i++) {
        if (prods[i] && prods[i].ok) paare.push({ r: results[i], p: prods[i] });
      }
      if (paare.length === 0) {
        cardsWrap.innerHTML = '<div class="vq-leer">' + V2.leer + '</div>';
        return;
      }
      rendere(paare, zubehoer);
    });
  }

  function rendere(paare, zubehoer) {
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '';
    var ueberrasch = QUESTIONS[2].options[answers[2]] && QUESTIONS[2].options[answers[2]].surprise === true;
    var top = paare[0];
    var rest = paare.slice(1);

    /* ── Kopfzeile: die gewaehlten Antworten als Chips ── */
    var personalEl = resultsEl.querySelector('.vq-results-personal');
    var chips = '';
    for (var qi = 0; qi < QUESTIONS.length; qi++) {
      if (answers[qi] === undefined) continue;
      var o = QUESTIONS[qi].options[answers[qi]];
      if (!o) continue;
      chips += '<span class="vq-chip">' + (o.icon || '') + ' ' + esc(o.label) + '</span>';
    }
    personalEl.innerHTML = '<div class="vq-chips">' + chips + '</div>' +
      '<h3 class="vq-erg-titel">' + (ueberrasch ? V2.titelUeberrasch : V2.titel.replace('{oel}', esc(top.p.titel))) + '</h3>' +
      '<p class="vq-erg-sub">' + (ueberrasch ? V2.subUeberrasch : V2.sub) + '</p>';

    /* ── Nr. 1 als Hauptkarte ── */
    var hero = document.createElement('div');
    hero.className = 'vq-hero';
    var oil = OILS[top.r.key];
    var vs = top.p.varianten;
    var gruende = begruendung();
    var n = ausgeschlossen();

    var h = '<div class="vq-hero-top">';
    if (top.p.bild) {
      h += '<img class="vq-hero-bild" src="' + top.p.bild + '&width=260" alt="' + esc(top.p.titel) + '" loading="eager" width="118" height="118">';
    }
    h += '<div class="vq-hero-kopf">';
    h += '<span class="vq-badge">' + (ueberrasch ? V2.badgeUeberrasch : V2.badge + (top.r.match ? ' · ' + top.r.match + '% Match' : '')) + '</span>';
    h += '<div class="vq-hero-name">' + esc(top.p.titel) + '</div>';
    h += '<div class="vq-hero-latein">' + esc(oil.latin) + '</div>';
    h += '</div></div>';

    if (ueberrasch) {
      h += '<div class="vq-warum-box"><b>' + V2.warumTitel + '</b><ul>';
      if (V2.q1[answers[0]]) h += '<li>' + V2.punkt1.replace('{x}', '<b>' + esc(QUESTIONS[0].options[answers[0]].label) + '</b>') + '</li>';
      if (V2.q2[answers[1]]) h += '<li>' + V2.punkt2.replace('{x}', '<b>' + esc(QUESTIONS[1].options[answers[1]].label) + '</b>') + '</li>';
      h += '<li>' + esc(oil.why) + '</li>';
      h += '</ul></div>';
    } else {
      if (gruende) h += '<div class="vq-warum">' + gruende + '</div>';
      h += '<p class="vq-hero-why">' + esc(oil.why) + '</p>';
    }
    h += '<div class="vq-hero-duft">🌬️ ' + UI.scentLabel + ' ' + esc(oil.scent) + '</div>';
    h += '<div class="vq-hero-tipp">' + UI.tipLabel + ' ' + esc(tippText(oil)) + '</div>';

    /* Groessenwahl - nur wenn es wirklich mehrere kaufbare Varianten gibt */
    if (vs.length > 1) {
      h += '<div class="vq-groessen" role="group" aria-label="' + V2.groesseLabel + '">';
      for (var i = 0; i < vs.length && i < 3; i++) {
        h += '<button type="button" class="vq-groesse' + (i === 0 ? ' vq-on' : '') + '" data-vid="' + vs[i].id +
             '" data-preis="' + vs[i].preis + '">' + esc(vs[i].titel) + '<small>' + fmtPreis(vs[i].preis) + '</small></button>';
      }
      h += '</div>';
    }
    h += '<button type="button" class="vq-haupt-cta vq-add-to-cart ajax-add-to-cart-btn" data-variant-id="' + vs[0].id + '">' +
         (ueberrasch ? V2.ctaUeberrasch : V2.cta) + ' <span class="vq-cta-preis">· ' + fmtPreis(vs[0].preis) + '</span></button>';
    h += '<a class="vq-hero-link" href="' + getProductUrl(top.p.handle) + '">' + V2.zurSeite + '</a>';
    h += '<div class="vq-hero-kosten">' + V2.proAnwendung.replace('{p}', (vs[0].preis / 100 / 250).toFixed(2).replace('.', ',')) + '</div>';
    if (n > 0) h += '<div class="vq-sicher">🛡️ ' + V2.sicher.replace('{n}', n) + '</div>';
    hero.innerHTML = h;
    cardsWrap.appendChild(hero);

    /* Groessenwahl verdrahten */
    var gBtns = hero.querySelectorAll('.vq-groesse');
    var cta = hero.querySelector('.vq-haupt-cta');
    for (var gi = 0; gi < gBtns.length; gi++) {
      gBtns[gi].addEventListener('click', function() {
        for (var k = 0; k < gBtns.length; k++) gBtns[k].classList.remove('vq-on');
        this.classList.add('vq-on');
        var vid = this.getAttribute('data-vid'), pr = parseInt(this.getAttribute('data-preis'), 10);
        cta.setAttribute('data-variant-id', vid);
        cta.querySelector('.vq-cta-preis').textContent = '· ' + fmtPreis(pr);
        hero.querySelector('.vq-hero-kosten').textContent = V2.proAnwendung.replace('{p}', (pr / 100 / 250).toFixed(2).replace('.', ','));
        aktualisiereSticky(top.p.titel, this.textContent, pr, vid);
      });
    }
    inKorb(cta, top.p.titel);
    hero.querySelector('.vq-hero-link').addEventListener('click', function() {
      trackEvent('quiz_product_click', { quiz_product: top.p.titel });
      sendToSheet({ t: 'click', lang: V2.lang, r1: top.p.titel });
    });

    /* ── Nr. 2 und 3 als kompakte Zeilen ── */
    if (rest.length) {
      var box = document.createElement('div');
      box.className = 'vq-v2-block';
      var rh = '<h4 class="vq-zwischen">' + (ueberrasch ? '' : V2.auchPassend) + '</h4>';
      if (ueberrasch) rh = '<details class="vq-alt"><summary>' + V2.altAufklappen + '</summary>';
      for (var j = 0; j < rest.length; j++) {
        var rp = rest[j];
        rh += '<div class="vq-zeile" data-vid="' + rp.p.varianten[0].id + '" data-name="' + esc(rp.p.titel) + '">';
        if (rp.p.bild) rh += '<img src="' + rp.p.bild + '&width=120" alt="" loading="lazy" width="52" height="52">';
        rh += '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(rp.p.titel) + '</div>' +
              '<div class="vq-zeile-m">' + (rp.r.match ? rp.r.match + '% Match · ' : '') + esc(rp.p.varianten[0].titel) + '</div></div>' +
              '<div class="vq-zeile-p">' + fmtPreis(rp.p.varianten[0].preis) + '</div>' +
              '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      }
      if (ueberrasch) rh += '</details>';
      box.innerHTML = rh;
      cardsWrap.parentNode.insertBefore(box, cardsWrap.nextSibling);
      verdrahteZeilen(box);

      /* Set-Knopf mit echtem Gesamtpreis */
      var summe = 0;
      for (var sj = 0; sj < paare.length; sj++) summe += paare[sj].p.varianten[0].preis;
      var setDiv = document.createElement('div');
      setDiv.className = 'vq-v2-block vq-set';
      setDiv.innerHTML = '<div class="vq-set-z"><span>' + V2.setTitel.replace('{n}', paare.length) + '</span><b>' + fmtPreis(summe) + '</b></div>' +
        '<button type="button" class="vq-set-btn">' + V2.setBtn + '</button>';
      box.parentNode.insertBefore(setDiv, box.nextSibling);
      setDiv.querySelector('.vq-set-btn').addEventListener('click', function() {
        var items = paare.map(function(x) { return { id: x.p.varianten[0].id, quantity: 1 }; });
        var b = this; b.disabled = true; b.textContent = V2.wirdHinzu;
        trackEvent('quiz_bundle_click');
        sendToSheet({ t: 'cart', lang: V2.lang, r1: 'SET (' + paare.length + ')' });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function() { window.location.href = DISCOUNT_URL; })
          .catch(function() { b.textContent = V2.fehler; b.disabled = false; });
      });
    }

    /* ── Zubehoer passend zur Anwendung ── */
    if (zubehoer && zubehoer.ok) {
      var zb = document.createElement('div');
      zb.className = 'vq-v2-block';
      zb.innerHTML = '<h4 class="vq-zwischen">' + V2.dazuPasst + '</h4>' +
        '<div class="vq-zeile" data-vid="' + zubehoer.varianten[0].id + '" data-name="' + esc(zubehoer.titel) + '">' +
        (zubehoer.bild ? '<img src="' + zubehoer.bild + '&width=120" alt="" loading="lazy" width="52" height="52">' : '') +
        '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(zubehoer.titel) + '</div>' +
        '<div class="vq-zeile-m">' + esc(V2.zubehoerText[answers[4]] || '') + '</div></div>' +
        '<div class="vq-zeile-p">' + fmtPreis(zubehoer.varianten[0].preis) + '</div>' +
        '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      cardsWrap.parentNode.appendChild(zb);
      verdrahteZeilen(zb);
    }

    /* ── Versandbalken ── */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      var schwelle = V2.versandSchwelle * 100;
      var fehlt = Math.max(0, schwelle - c.total_price);
      var vb = document.createElement('div');
      vb.className = 'vq-v2-block vq-versand';
      vb.innerHTML = (fehlt > 0
        ? V2.versandNoch.replace('{x}', '<b>' + fmtPreis(fehlt) + '</b>')
        : V2.versandFrei) +
        '<div class="vq-bar"><i style="width:' + Math.min(100, Math.round(c.total_price / schwelle * 100)) + '%"></i></div>';
      cardsWrap.parentNode.appendChild(vb);
    }).catch(function() {});

    /* ── Rabattcode, kompakt ── */
    var db = document.createElement('div');
    db.className = 'vq-v2-block vq-code';
    db.innerHTML = '<div><span class="vq-code-c">' + DISCOUNT_CODE + '</span><small>' + V2.codeText + '</small></div>' +
      '<a class="vq-code-btn" href="' + DISCOUNT_URL + '">' + V2.codeBtn + '</a>';
    cardsWrap.parentNode.appendChild(db);
    db.querySelector('.vq-code-btn').addEventListener('click', function() {
      trackEvent('quiz_discount_apply', { quiz_code: DISCOUNT_CODE });
    });

    /* ── Sticky-Kaufleiste (70 % der Nutzer sind am Handy) ── */
    var sticky = document.createElement('div');
    sticky.className = 'vq-sticky';
    sticky.innerHTML = '<div class="vq-sticky-t"><div class="vq-sticky-n"></div><div class="vq-sticky-p"></div></div>' +
      '<button type="button" class="vq-sticky-btn">' + V2.cta + '</button>';
    quizEl.appendChild(sticky);
    aktualisiereSticky(top.p.titel, vs[0].titel, vs[0].preis, vs[0].id);
    sticky.querySelector('.vq-sticky-btn').addEventListener('click', function() {
      var b = hero.querySelector('.vq-haupt-cta');
      if (b) b.click();
    });
    var beobachter = new IntersectionObserver(function(eintraege) {
      sticky.classList.toggle('vq-sichtbar', !eintraege[0].isIntersecting);
    }, { threshold: 0 });
    beobachter.observe(hero.querySelector('.vq-haupt-cta'));

    clearProgress();
    surveyEl.style.display = 'none';
    surveySubmitted = false;
    setTimeout(function() { if (!surveySubmitted) surveyEl.style.display = 'block'; }, 8000);
  }

  function aktualisiereSticky(name, groesse, preis, vid) {
    var st = quizEl.querySelector('.vq-sticky');
    if (!st) return;
    st.querySelector('.vq-sticky-n').textContent = name + (groesse ? ' · ' + String(groesse).split('\n')[0] : '');
    st.querySelector('.vq-sticky-p').textContent = fmtPreis(preis) + ' · ' + V2.versandKurz;
    st.setAttribute('data-vid', vid);
  }

  function verdrahteZeilen(wurzel) {
    var zeilen = wurzel.querySelectorAll('.vq-zeile');
    for (var i = 0; i < zeilen.length; i++) {
      (function(z) {
        z.querySelector('.vq-plus').addEventListener('click', function() {
          var vid = parseInt(z.getAttribute('data-vid'), 10);
          var nm = z.getAttribute('data-name');
          var b = this;
          if (!vid) return;
          b.disabled = true; b.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
            .then(function() {
              b.textContent = '✓'; b.classList.add('vq-ok');
              trackEvent('quiz_add_to_cart', { quiz_product: nm });
              sendToSheet({ t: 'cart', lang: V2.lang, r1: nm });
              setTimeout(function() { b.textContent = '+'; b.classList.remove('vq-ok'); b.disabled = false; }, 2200);
            })
            .catch(function() { b.textContent = '!'; b.disabled = false; });
        });
      })(zeilen[i]);
    }
  }

  function inKorb(btn, name) {
    btn.addEventListener('click', function() {
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      var alt = btn.innerHTML;
      btn.disabled = true; btn.textContent = V2.wirdHinzu;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function() {
          btn.innerHTML = '✓ ' + V2.imKorb;
          btn.classList.add('vq-ok');
          trackEvent('quiz_add_to_cart', { quiz_product: name });
          sendToSheet({ t: 'cart', lang: V2.lang, r1: name });
          setTimeout(function() { btn.innerHTML = alt; btn.classList.remove('vq-ok'); btn.disabled = false; }, 2500);
        })
        .catch(function() { btn.textContent = V2.fehler; btn.disabled = false; });
    });
  }

  /* Tipp passend zur gewaehlten Anwendung (Frage 5), sonst der Standardtipp. */
  function tippText(oil) {
    if (answers[4] !== undefined && V2.tipp[answers[4]]) return V2.tipp[answers[4]];
    return oil.tip;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  quizEl.querySelector('.vq-start-btn').addEventListener('click', startQuiz);

  quizEl.querySelector('.vq-btn-back').addEventListener('click', goBack);



  (function() {

    var saved = loadProgress();

    if (!saved) return;

    var startBtn = quizEl.querySelector('.vq-start-btn');

    var resumeBtn = document.createElement('button');

    resumeBtn.className = 'vq-btn vq-btn-primary';

    resumeBtn.style.cssText = 'background:#2d572c;margin-top:0.5rem;';

    resumeBtn.textContent = '↻ Continue where you left off (Question ' + (saved.step + 1) + ')';

    startBtn.parentNode.insertBefore(resumeBtn, startBtn.nextSibling);

    startBtn.textContent = 'Start over';

    startBtn.className = 'vq-btn vq-btn-back';

    resumeBtn.addEventListener('click', function() { resumeQuiz(saved); });

  })();



  var restartBtn = quizEl.querySelector('.vq-btn-restart');

  restartBtn.addEventListener('click', function() {

    currentStep = -1;

    answers = [];

    clearProgress();

    surveySubmitted = false;

    quizEl.querySelector('.vq-survey-thanks').style.display = 'none';

    surveyEl.style.display = 'none';

    showScreen('intro');

  });



  /* ── SURVEY ── */

  var surveyEl = quizEl.querySelector('.vq-survey');

  var quizStars = quizEl.querySelectorAll('#vq-stars-quiz .vq-star');

  var oilsStars = quizEl.querySelectorAll('#vq-stars-oils .vq-star');

  var quizRating = 0;

  var oilsRating = 0;

  var surveySubmitted = false;



  function setupStars(stars, setRating) {

    for (var si = 0; si < stars.length; si++) {

      (function(star, allStars) {

        star.addEventListener('click', function() {

          var val = parseInt(this.getAttribute('data-value'), 10);

          setRating(val);

          for (var j = 0; j < allStars.length; j++) {

            allStars[j].classList.toggle('vq-star-active', parseInt(allStars[j].getAttribute('data-value'), 10) <= val);

          }

        });

        star.addEventListener('mouseenter', function() {

          var hv = parseInt(this.getAttribute('data-value'), 10);

          for (var j = 0; j < allStars.length; j++) {

            allStars[j].classList.toggle('vq-star-hover', parseInt(allStars[j].getAttribute('data-value'), 10) <= hv);

          }

        });

        star.addEventListener('mouseleave', function() {

          for (var j = 0; j < allStars.length; j++) { allStars[j].classList.remove('vq-star-hover'); }

        });

      })(stars[si], stars);

    }

  }



  setupStars(quizStars, function(val) { quizRating = val; });

  setupStars(oilsStars, function(val) { oilsRating = val; });



  quizEl.querySelector('.vq-btn-survey-submit').addEventListener('click', function() {

    if ((quizRating === 0 && oilsRating === 0) || surveySubmitted) return;

    var comment = quizEl.querySelector('#vq-survey-tips').value || '';

    var emailInput = quizEl.querySelector('#vq-survey-email');

    var email = emailInput ? (emailInput.value || '').trim() : '';

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {

      emailInput.style.borderColor = '#dc2626';

      emailInput.focus();

      return;

    }

    sendToSheet({

      t: 'feedback', lang: 'en',

      stars_quiz: quizRating, stars_oils: oilsRating,

      comment: comment.substring(0, 200),

      email: email.substring(0, 100)

    });

    trackEvent('quiz_feedback', { quiz_stars: quizRating, oils_stars: oilsRating, has_email: email ? 1 : 0 });

    surveySubmitted = true;

    surveyEl.style.display = 'none';

    quizEl.querySelector('.vq-survey-thanks').style.display = 'block';

  });



})();

